export const colorStyles = [
    '#f2f4f7',
    '#f3fee7',
    '#fef3f2',
    '#fffaeb',
    '#ecfdf3',
    '#f8f9fc',
    '#f0f9ff',
    '#f0f9ff',
    '#eff8ff',
    '#eef4ff',
    '#f4f3ff',
    '#fdf2fa',
    '#fff1f3',
    '#fff4ed',
    '#16b364',
    '#2e90fa',
    '#7a5af8',
    '#ee46bc',
    '#ff4405',
    '#ef6820',
    '#eaaa08',
];
export const randomColor = (index = 0) => {
    return colorStyles[index % colorStyles.length];
};
//# sourceMappingURL=utils.js.map